import { render } from "./App.vue?vue&type=template&id=df8124ca"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=df8124ca&lang=css"

import exportComponent from "/Users/jipfens/Library/Mobile Documents/com~apple~CloudDocs/iProjects/lexis/lexis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__